import React, { useState, useEffect } from "react";
// import cx from "classnames";
import PropTypes from "prop-types";
import search from "api/search/search.js";
import config from "config/config.js";

// @material-ui/core components
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { NavLink } from "react-router-dom";

import tbProfile from "api/user/tbProfile.js";
import getAttributes from "api/getAttributes.js";
import logout from "api/authentication/logout.js";

export default function Header(props) {
  const [user, setUser] = useState({});
  const buttonRef = React.useRef();

  const [anchorEl, setAnchorEl] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    tbProfile()
      .then(res => {
        setUser(res);
        props.updateUser(res);
      })
      .catch(err => console.log("error", err));
    getAttributes()
      .then(res => {
        props.updateAttributes(res);
      })
      .catch(err => console.log("error", err));
  }, []);
  // console.log(props.user);
  return (
    <>
      <div className="header-container">
        <a
          className="header-logo"
          // onClick={() => {
          // }}
          href="/"
        >
          <img
            src="https://cdn.foodiestrip.com/tourist_wallet/loghi/TW_color_black_orange.png"
            alt="foodiestrip-logo"
            title="foodiestrip"
            className="logo_desktop"
          />
          <img
            src="https://cdn.foodiestrip.com/tourist_wallet/loghi/TW_color_black_orange.png"
            alt="foodiestrip-logo"
            title="foodiestrip"
            className="logo_mobile"
          />
        </a>
        {props.user &&
        props.user.userDataId &&
        props.user.userDataId.profileImageUrl ? (
          <div
            className="header-user-image"
            id="men"
            aria-haspopup="true"
            ref={buttonRef}
            style={{
              position: "relative",
              backgroundImage: `url('${props.user.userDataId.profileImageUrl}')`
            }}
            onClick={event => {
              // logout();
              // setAnchorEl(event.currentTarget);
              setOpen(!open);

              // window.location.href = "http://localhost:3000/userData";
            }}
          >
            <Menu
              id="simple-menu"
              anchorEl={() => buttonRef.current}
              // anchorEl={anchorEl ? anchorEl : false}
              keepMounted
              open={Boolean(open)}
              onClose={() => {
                setOpen(!open);
              }}
            >
              <NavLink
                to={"/userData"}
                // className={classes.itemLink + " " + classes.userCollapseLinks}
                className="user-menu-link"
              >
                <MenuItem
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  Profile
                </MenuItem>
              </NavLink>
              <NavLink
                to={"/userCheck"}
                className="user-menu-link"
                // className={classes.itemLink + " " + classes.userCollapseLinks}
              >
                <MenuItem
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  Check-in
                </MenuItem>
              </NavLink>
              <NavLink
                to={"/userFavorites"}
                className="user-menu-link"
                // className={classes.itemLink + " " + classes.userCollapseLinks}
              >
                <MenuItem
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  Preferiti
                </MenuItem>
              </NavLink>
              <NavLink
                to={"/userReviews"}
                className="user-menu-link"
                // className={classes.itemLink + " " + classes.userCollapseLinks}
              >
                <MenuItem
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  Recensiti
                </MenuItem>
              </NavLink>
              <NavLink
                to={"/"}
                className="user-menu-link"
                // className={classes.itemLink + " " + classes.userCollapseLinks}
              >
                <MenuItem
                  onClick={() => {
                    logout();
                    setOpen(false);
                  }}
                >
                  Esci
                </MenuItem>
              </NavLink>
            </Menu>
          </div>
        ) : (
          <div className="header-login">
            <div className="header-login-desktop">
              {/* <a
              href="/signup"
              title="Sign-up foodiestrip"
              className="right-separator"
            >
              Preferiti
            </a> */}
              {/* <a
              href="/signup"
              title="Sign-up foodiestrip"
              className="right-separator"
            >
              Registrati
            </a> */}
              <NavLink
                to={"/signup"}
                // className={classes.itemLink + " " + classes.userCollapseLinks}
                className="right-separator"
              >
                Registrati
              </NavLink>
              <NavLink
                to={"/login"}
                // className={classes.itemLink + " " + classes.userCollapseLinks}
                className="user-menu-link"
              >
                Login <i className="far fa-user icon-user" />
              </NavLink>
              {/* <a href="/login" title="Login foodiestrip">
              Login <i className="far fa-user icon-user" />
            </a> */}
            </div>
            <div className="header-login-mobile">
              <i
                className="header-user-image mobile-menu-icon fas fa-bars icon-user"
                id={"mobile-menu-icon"}
                aria-haspopup="true"
                style={{
                  position: "relative"
                }}
                onClick={event => {
                  // logout();
                  setAnchorEl(event.currentTarget);
                  setOpen(!open);
                }}
              >
                <Menu
                  id="mobile-menu"
                  // anchorEl={anchorEl}
                  anchorEl={() => buttonRef.current}
                  keepMounted
                  open={Boolean(open)}
                  onClose={() => {
                    setOpen(!open);
                  }}
                >
                  <NavLink
                    to={"/signup"}
                    // className={classes.itemLink + " " + classes.userCollapseLinks}
                    className="user-menu-link"
                  >
                    <MenuItem
                      onClick={() => {
                        setOpen(false);
                      }}
                    >
                      Registrati
                    </MenuItem>
                  </NavLink>
                  <NavLink
                    to={"/login"}
                    // className={classes.itemLink + " " + classes.userCollapseLinks}
                    className="user-menu-link"
                  >
                    <MenuItem
                      onClick={() => {
                        logout();
                        setOpen(false);
                      }}
                    >
                      Login
                    </MenuItem>
                  </NavLink>
                </Menu>
              </i>
            </div>{" "}
          </div>
        )}
      </div>
      {props.user &&
      props.user.userDataId &&
      props.user.userDataId.profileImageUrl ? (
        <div className="margin-header" />
      ) : (
        <div className="signup-login-mobile">
          <NavLink
            to={"/signup"}
            // className={classes.itemLink + " " + classes.userCollapseLinks}
            className="signup-login-link"
          >
            Registrati
          </NavLink>
          <NavLink
            to={"/login"}
            // className={classes.itemLink + " " + classes.userCollapseLinks}
            className="signup-login-link"
            style={{ borderLeft: "solid 1px #aba69e" }}
          >
            Login
          </NavLink>
        </div>
      )}
    </>
  );
}

Header.propTypes = {
  updateCity: PropTypes.func,
  updateUser: PropTypes.func,
  updateAttributes: PropTypes.func,
  user: PropTypes.object
};
